export default "__VITE_ASSET__BEtneclt__"